import React from 'react';
import { motion } from 'framer-motion';

const ACCENT = {
  indigo: 'from-indigo-500 to-purple-600',
  blue: 'from-blue-500 to-indigo-600',
  purple: 'from-purple-500 to-pink-600',
  yellow: 'from-amber-500 to-orange-500',
  green: 'from-emerald-500 to-green-600',
  red: 'from-rose-500 to-red-600',
  gray: 'from-slate-400 to-gray-500',
};

const KpiCard = ({ icon: Icon, label, value, sub, accent = 'indigo', isLoading, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, delay }}
    className="relative overflow-hidden bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200"
  >
    <div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${ACCENT[accent] || ACCENT.indigo}`} />
    <div className="p-5">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">{label}</span>
        {Icon && (
          <div className={`p-2 rounded-lg bg-gradient-to-r ${ACCENT[accent] || ACCENT.indigo}`}>
            <Icon className="h-4 w-4 text-white" />
          </div>
        )}
      </div>
      <div className="min-h-[2.25rem] flex items-end">
        {isLoading ? (
          <div className="animate-pulse bg-gray-200 h-8 w-24 rounded" />
        ) : (
          <h3 className="text-2xl font-bold text-gray-900 tabular-nums">{value}</h3>
        )}
      </div>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  </motion.div>
);

export default KpiCard;
